const BASE_URI = String(process.env.REACT_APP_BASE_URI);
const API_PREFIX = '/api';
const UAPI_TOKEN = '133b94a5a99b4eab829c63590d6e491f';

export default {
  BASE_URI,
  API_PREFIX,
  UAPI_TOKEN,
};
